export default __webpack_public_path__ + "close13f8f3.svg";